import { IBFile } from './UploadAttachment.types';
import { UploadAttachmentsType } from '../InputFile/InputFile.types';

export const removeDuplicates = (files: IBFile[]) => {
  const result: IBFile[] = [];
  files.forEach(f => {
    if (!result.some(r => r.fileName === f.fileName)) {
      result.push(f);
    }
  });
  return result;
};

export const onFileChange = (
  e: File | File[],
  value: IBFile | IBFile[],
  type: UploadAttachmentsType,
  onChange?: (files: IBFile[] | IBFile) => void
) => {
  if (
    onChange &&
    type === 'single' &&
    (!value || (value as IBFile).fileName === (e as File).name)
  ) {
    onChange({
      blobId: null,
      fileName: (e as File).name,
      file: e as File,
      fileType: 0,
      contentType: (e as File).type,
      fileLength: (e as File).size
    });
  } else if (onChange && type === 'multi') {
    const newValue = removeDuplicates([
      ...(value ? (value as IBFile[]) : []),
      ...(e as File[]).map(f => {
        return {
          blobId: null,
          file: f,
          fileName: f.name,
          fileType: 0,
          contentType: (e as File).type,
          fileLength: (e as File).size
        };
      })
    ]);
    onChange(newValue);
  }
};

export const onTagClick = (
  file: IBFile,
  onDownloadAttachment: (file: IBFile) => void
) => {
  if (file && onDownloadAttachment) {
    onDownloadAttachment(file);
  }
};
